import { createSlice, createSelector } from "@reduxjs/toolkit";
import { RootState } from "../../store";
import { Organization } from "../model/organization";
import { addChildOrganizationsToOrganization, deleteOrganizations, fetchOrganizations } from "./asyncThunks";

export const initialOrganizationState = {
    open: false,
    error: null
};

export const addChildOrganizationsSlice = createSlice({
    name: "addChildOrganizations",
    initialState: initialOrganizationState,
    reducers: {
        onChangeDialog: (state, action): void => {
            state.open = action.payload.open;
        },
        clearAddChildError: (state): void => {
            state.error = null;
        },
    },
    extraReducers: {
        [`${addChildOrganizationsToOrganization.rejected}`]: (state, action): void => {
            state.error = action.payload
        },
    },
});

// Actions
export const { onChangeDialog, clearAddChildError } = addChildOrganizationsSlice.actions;

// Selectors
export const isOpenDialogSelector = (state: RootState): boolean => state.addChildOrganizations.open;

export const errorSelector = createSelector(
    (state: RootState): any => state.addChildOrganizations.error,
    (error: any) => error
);